import { useState } from "react";

/**
 * customHook para controlar si existe authenticación o no
 *
 * @param {String} user
 * @returns user o false
 */
export function useAuth(user) {
  const [authed, setAuthed] = useState(() => {
    const authed = true;
    return user !== null && user !== undefined ? authed : false;
  });

  return [authed, setAuthed];
}
